export default {
  MuiSlider: {
    thumb: {
      width: 28,
      height: 28,
      marginTop: -13,
    },
  },
};
